export type ErrorCode = 404 | 400 | 500;

export class ApiError extends Error {
  constructor(message: string, public readonly code: ErrorCode, public data?: any) {
    super(message);
    console.warn(message, code, data);
  }
}

export class ValidationError extends ApiError { }
export class FetchFailedError extends ApiError { }
export class UnableToCompleteError extends ApiError { }
